<template>
  <div
    style="
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      border-left: 1px solid #e2e2e2;
      border-top: 1px solid #e2e2e2;
    "
  >
    <div
      style="
        display: flex;
        border-right: 1px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
      "
      v-for="item in props.sortFields"
      :key="item"
    >
      <li
        style="
          flex: 1;
          background-color: #f5f7fa;
          padding: 10px;
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          border-right: 1px solid #e2e2e2;
        "
      >
        {{ item.name }}
      </li>
      <li style="flex: 1.5; padding: 10px">
        <el-input-number
          v-if="item.edit"
          v-model="state.model[item.field]"
          :controls="false"
          class="number-input-left number-input-suffix"
          :precision="2"
          suffix="元"
          style="width: 100%"
        ></el-input-number>
        <text v-else>{{ state.model[item.field] || "-" }}</text>
      </li>
    </div>
  </div>
  <div
    style="
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 20px;
    "
  >
    <el-button @click="onClose">取消</el-button>
    <el-button type="primary" @click="onConfirm">提交</el-button>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  props: {
    model: Object,
    sortFields: Array,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.model = JSON.parse(JSON.stringify(props.model));
    });

    const onClose = () => {
      emit("close");
    };

    const onConfirm = () => {
      emit("confirm", state.model);
    };

    return { state, props, onClose, onConfirm };
  },
};
</script>
<style scoped></style>
